import { StrictMode } from 'react';
import { createRoot, hydrateRoot, type Root } from 'react-dom/client';

import { App } from './App';
import type { SitePage } from './types';

/**
 * Vite's development fallback serves index.html with an empty #root, while
 * prerendered production documents include server markup. Choose the matching
 * React entrypoint so both paths mount the reader.
 */
export function mountApp(root: Element, initialPath: string, initialPage: SitePage | null): Root {
  const app = <StrictMode><App initialPath={initialPath} initialPage={initialPage} /></StrictMode>;
  if (root.hasChildNodes()) return hydrateRoot(root, app);
  const clientRoot = createRoot(root);
  clientRoot.render(app);
  return clientRoot;
}
